//Ye niche wale main property list hai jab hum kisi object ko select krte hai to ye use object ki property show krta hai 
// for example support I click on recording square button which is on canvas then it will trigger RecordingP which has component of <Position canvas={canvas} /> where we set postion of recording object
  
 
import ChapterListModal from "../modal/ChpaterListModal";
import DownloadVideoModal from "../modal/DownloadVideoModal";
import WatchOnTvModal from "../modal/WatchOnTvModal";

class Icons { 
 static ChapterListModal = ChapterListModal;
 static DownloadVideoModal =DownloadVideoModal; 
 static WatchOnTvModal = WatchOnTvModal;
}

export default Icons;
